// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pubchEntity from './entities/pubch.json';
import pubchMenu from '../pages/pubch/menu.json';
import pubchFullForm from '../pages/pubch/forms/full.json';
import pubchContextForm from '../pages/pubch/forms/context.json';
import pubchMiniForm from '../pages/pubch/forms/mini.json';
import pubchLookupForm from '../pages/pubch/forms/lookup.json';
import pubchTableView from '../pages/pubch/views/table.json';
import pubchStagesView from '../pages/pubch/views/stages.json';
import pubchCardsView from '../pages/pubch/views/cards.json';
import pubchInlineView from '../pages/pubch/views/inline.json';
import pubchBacklogView from '../pages/pubch/views/backlog.json';
import pubchSplitView from '../pages/pubch/views/split.json';
import pubchCalendarView from '../pages/pubch/views/calendar.json';
import pubchDashboardView from '../pages/pubch/views/dashboard.json';
import pubchPcoverView from '../pages/pubch/views/pcover.json';

/** Тип запису «Виклик» зі сторінками пакета: меню, форми та подання з pages/pubch/. */
export const pubchDefinition: IRecordTypeDefinition = {
  ...pubchEntity,
  views: assembleViewSet({
      table: pubchTableView,
      stages: pubchStagesView,
      cards: pubchCardsView,
      inline: pubchInlineView,
      backlog: pubchBacklogView,
      split: pubchSplitView,
      calendar: pubchCalendarView,
      dashboard: pubchDashboardView,
      pcover: pubchPcoverView,
  }),
  form: pubchFullForm,
  forms: { full: pubchFullForm, context: pubchContextForm, mini: pubchMiniForm, lookup: pubchLookupForm },
  menu: pubchMenu,
} as IRecordTypeDefinition;
